export default __webpack_public_path__ + "favicon.459e0e4e.ico";